export default "__VITE_ASSET__C_rVbPac__"